import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import ReactPaginate from 'react-paginate';

export default function Conflict() {
    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    const baseUrl = nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

    const [challenge, setchallenge] = useState()
    const [pageNumber, setPageNumber] = useState(0);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [search, setSearch] = useState('');

    const Allchallenge = (page = pageNumber, lim = limit, q = search) => {
        const access_token = localStorage.getItem('token')
        const headers = { Authorization: `Bearer ${access_token}` }
        let url = baseUrl + `challange/conflict_challange?page=${page}&_limit=${lim}`;
        if (q) url += `&_q=${encodeURIComponent(q)}&_stype=Name`;
        axios.get(url, { headers })
            .then((res) => {
                setchallenge(res.data.status || [])
                setTotalPages(res.data.totalPages || 0);
                setPageNumber(page);
                setLimit(lim);
                setSearch(q);
            })
            .catch(err => console.log(err))
    }

    const dateFormat = (e) => {
        if (!e) return "N/A";
        const date = new Date(e);
        return date.toLocaleString('default', { month: 'short', day: 'numeric', hour: 'numeric', hour12: true, minute: 'numeric' });
    }

    useEffect(() => {
        Allchallenge(0, limit, '')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (challenge === undefined) {
        return null
    }

    const displayStatus = (game) => {
        const creatorSubmitted = game.Creator_Status !== null && game.Creator_Status !== undefined && game.Creator_Status !== "";
        const acceptorSubmitted = game.Acceptor_status !== null && game.Acceptor_status !== undefined && game.Acceptor_status !== "";
        if ((game.Status || "").toLowerCase() === "conflict" || (creatorSubmitted && acceptorSubmitted)) {
            return "conflict";
        }
        return game.Status;
    }

    return (
        <div className="conflict-challenges-container p-2 p-md-4">
            <style>{`
                .conflict-challenges-container { background: #f0f2f5; min-height: 100vh; font-family: 'Poppins', sans-serif; }
                .header-card { background: #fff; padding: 20px; border-radius: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.05); margin-bottom: 25px; }
                
                .table-card-main { background: #ffffff; border-radius: 25px; overflow: hidden; box-shadow: 0 15px 35px rgba(0,0,0,0.1); border: none; }
                .table-banner-header { background: linear-gradient(45deg, #4b0000, #991b1b); color: #ffffff !important; padding: 18px 25px; font-weight: 700; font-size: 1.1rem; }
                
                /* Responsive Table Fix */
                .table-responsive-wrapper { width: 100%; overflow-x: auto; -webkit-overflow-scrolling: touch; background: #fff; }
                .custom-table-conflict { width: 100%; border-collapse: collapse; min-width: 1000px; table-layout: auto; }
                
                .custom-table-conflict th { background: #f8f9fa; color: #334155 !important; padding: 15px 12px; font-weight: 800; text-transform: uppercase; font-size: 0.75rem; border-bottom: 2px solid #edf2f7; text-align: center; white-space: nowrap; }
                .custom-table-conflict td { padding: 15px 12px; vertical-align: middle; border-bottom: 1px solid #f1f1f1; font-size: 0.85rem; color: #000 !important; text-align: center; font-weight: 600; white-space: nowrap; }
                .custom-table-conflict tbody tr:hover { background-color: #fff1f2; }

                .status-badge-conflict { background: #fee2e2; color: #991b1b !important; padding: 6px 12px; border-radius: 10px; font-weight: 700; font-size: 0.7rem; text-transform: uppercase; border: 1px solid #fecaca; }
                .btn-view-action { background: #1e293b; color: white !important; border-radius: 8px; font-weight: 700; font-size: 0.8rem; padding: 8px 16px; border: none; transition: 0.3s; text-decoration: none; display: inline-block; }
                .btn-view-action:hover { transform: translateY(-2px); background: #0f172a; box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2); }

                @media (max-width: 768px) {
                    .header-card h3 { font-size: 1.2rem; }
                    .table-banner-header { font-size: 1rem; padding: 15px; }
                }
                .toolbar-conflict { display: flex; flex-wrap: wrap; gap: 10px; align-items: center; padding: 15px 20px; background: #fff; }
                .toolbar-conflict input, .toolbar-conflict select { padding: 8px 12px; border-radius: 8px; border: 1px solid #ddd; }
                .toolbar-conflict input { flex: 1 1 220px; }
                .pagination-wrapper { display: flex; justify-content: center; padding: 20px; }
                .pagination-wrapper ul { list-style: none; display: flex; gap: 5px; padding: 0; margin: 0; flex-wrap: wrap; }
                .pagination-wrapper li a { display: block; padding: 6px 12px; border-radius: 6px; border: 1px solid #eee; color: #991b1b; cursor: pointer; font-size: 0.85rem; }
                .pagination-wrapper li.active a { background: #991b1b; color: #fff; border-color: #991b1b; }
            `}</style>

            <div className="header-card">
                <h3 className="m-0" style={{fontWeight: 900, color: '#991b1b'}}>Conflict <span style={{color: '#1e293b'}}>Management</span></h3>
                <p className="text-muted m-0" style={{fontSize: '0.85rem'}}>Resolve disputes and verify match results</p>
            </div>

            <div className="table-card-main">
                <div className="table-banner-header">⚠️ Disputed Challenges (Conflicts)</div>
                <div className="toolbar-conflict">
                    <input
                        type="text"
                        placeholder="Search by player name..."
                        defaultValue={search}
                        onKeyDown={(e) => { if (e.key === 'Enter') Allchallenge(0, limit, e.target.value); }}
                    />
                    <select value={limit} onChange={(e) => Allchallenge(0, e.target.value, search)}>
                        <option value="10">Show 10</option>
                        <option value="20">Show 20</option>
                        <option value="50">Show 50</option>
                        <option value="100">Show 100</option>
                    </select>
                </div>
                <div className="table-responsive-wrapper">
                    <table className="custom-table-conflict">
                        <thead>
                            <tr>
                                <th style={{width: '60px'}}>#</th>
                                <th>Challenge ID</th>
                                <th>Creator</th>
                                <th>Accepter</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Game Type</th>
                                <th>Date Created</th>
                                <th style={{width: '120px'}}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {challenge && challenge.length > 0 ? challenge.map((game, key) => (
                                <tr key={game._id}>
                                    <td style={{color: '#64748b'}}>#{(pageNumber > 0 ? (pageNumber - 1) * limit : 0) + key + 1}</td>
                                    <td style={{fontFamily: 'monospace', color: '#991b1b !important'}}>{game._id}</td>
                                    <td style={{fontWeight: 700}}>{game.Created_by ? game.Created_by.Name : '---'}</td>
                                    <td style={{fontWeight: 700}}>{game.Accepetd_By ? game.Accepetd_By.Name : '---'}</td>
                                    <td style={{color: '#15803d !important', fontWeight: '800'}}>₹{game.Game_Ammount}</td>
                                    <td><span className="status-badge-conflict">{displayStatus(game)}</span></td>
                                    <td style={{textTransform: 'capitalize'}}>{game.Game_type}</td>
                                    <td style={{fontSize: '0.75rem', color: '#64748b'}}>{dateFormat(game.createdAt)}</td>
                                    <td>
                                        <Link className="btn-view-action" to={`/view/${game._id}`}>
                                            <i className="fa fa-gavel mr-2"></i> Resolve
                                        </Link>
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="9" className="text-center py-5" style={{color: '#94a3b8', fontSize: '1.1rem'}}>
                                        No active conflicts found. System is clear!
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {totalPages > 1 && (
                    <div className="pagination-wrapper">
                        <ReactPaginate
                            previousLabel={"←"}
                            nextLabel={"→"}
                            breakLabel={"..."}
                            pageCount={totalPages}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={2}
                            onPageChange={(data) => Allchallenge(data.selected + 1, limit, search)}
                            containerClassName={"pagination"}
                            pageClassName={"page-item"}
                            activeClassName={"active"}
                            forcePage={pageNumber > 0 ? pageNumber - 1 : 0}
                        />
                    </div>
                )}
            </div>
        </div>
    )
}
